export const getDomainNameHeaderValue = () => {
  if (typeof window === "undefined") {
    return ""
  }

  let domain = window.location.hostname
  if (
    domain === "localhost" ||
    domain === "dev.vienvu.com" ||
    domain === "127.0.0.1"
  ) {
    // domain = "erp.nuocdahongphuc.com"
    // domain = "app.nhakhoadrchau.com"
    // domain = "weg.gratisoft.tech"
    domain = "hpi.gratisoft.tech"
    // domain = "erp.dnacare.com.vn"
    // domain = 'we.worldexport.com.vn'
  }
  return domain
}
